import PropTypes from 'prop-types';
import * as React from 'react';
import type {ColumnPropType, RowPropType} from './propTypes';
import {columnPropType, rowPropType} from './propTypes';
import {getCellClassName, getCellStyle} from './utils';

export type Props = {
    column: ColumnPropType,
    row: RowPropType,
    children?: React.ReactNode,
}

export default class DataTableBodyCell extends React.PureComponent<Props> {

    static propTypes = {
        column: columnPropType.isRequired,
        row: rowPropType.isRequired,
        children: PropTypes.node,
    };

    props: Props;

    render(): React.ReactNode {
        const {
            style: baseStyle,
            className: baseClassName,
            column,
            row,
            children,
            ...otherProps
        } = this.props;

        const style = getCellStyle(column, style);
        const className = getCellClassName(column, baseStyle, true);

        return (
            <td className={className} style={style} {...otherProps}>
                {children}
            </td>
        );
    }

}
